import "./App.css";
import BackGround from "./Components/BackGround";

function App() {
  return (
    <div className="">
      <BackGround />
    </div>
  );
}

export default App;
